export enum RetailProductsDataIndex {
  'name' = 'name',
  'item_description' = 'item_description',
  'retail_categories.name' = 'retail_categories.name',
  'impairments.name' = 'impairments.name',
  'updated_at' = 'updated_at',
}
